import { render, staticRenderFns } from "./Syndication.vue?vue&type=template&id=9d65fb7c&"
import script from "./Syndication.vue?vue&type=script&lang=js&"
export * from "./Syndication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports